import React from 'react';
import { Card } from "react-bootstrap";
import face_image from "../../assets/img/faceXinzheZhang.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projXinzheZ_highway.png";

const Zhang_Xinzhe_highway = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_image}
              /* this will be the text on the banner */
              alt="Interaction-Aware Detection of Key Time Intervals in Highway Ramp Merging Trajectories"
            />{" "}
            <p className="text7">Zhang Xinzhe </p>
            <br />
            <p className="text8">
              PhD Student{" "}
            </p>
            <p className="text8">Department of Control for Transportation and Vehicle Systems, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            This project focuses on highway ramp merging events. Based on vehicle trajectory time series, the
            project aims to automatically identify key phases of the merging process, including the preparation
            phase, the merging execution phase, and the post-merge stabilization phase. For each detected
            phase, the method will output the start and end times, a confidence score, and abnormality flags.
            In parallel, gap- and safety-related indicators between the merging vehicle and nearby main-lane
            vehicles (such as TTC, distance, relative speed, and neighbor occupancy) will be used for frame-
            level classification into INTERACT / NATURAL / UNCERTAIN. The project will then study
            how the key intervals differ under different interaction conditions.
            <br/>
            <br/>
            Methodologically, the project will compare several interpretable approaches for time-series
            segmentation and state identification, including multivariate change-point detection,
            HMM/HSMM-based state modeling, and optimization-based segmentation using dynamic
            programming or convex surrogate formulations. Robustness will also be evaluated under
            trajectory noise, missing information, and data collected from different locations.
            <br/>
            <br/>
            The final deliverables include a reusable Python module for key-interval labeling, a unified
            benchmark script, and a visual report. The goal is to build an extensible and reproducible method
            for labeling key merging intervals.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Zhang_Xinzhe_highway;